export default {"src":"/_next/static/media/key-cybersecurity-stakeholders.137c36cf.svg","height":314,"width":314,"blurWidth":0,"blurHeight":0};